import {BUS_NAVIGATION_CHANGED} from "../@const";


export default async function navigation_pin(navigationSectionId:string) {

    console.log("navigation_pin", navigationSectionId)

    gd.layout.toggleHideMenuForCurrentApp(true)

    gd.navigationStructure.initSections()

    const section = gd.navigationStructure.get(navigationSectionId)

    await gd.layout.navigation.setCurrentSection(section)

    // await gd.layout.navigation.reRender()
    await gd.layout.mainMenuStatic?.reRender()

    gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED)
}
